import React from 'react'
import s from './list-item.module.css'

const ListItem = (props) => {
    return (
        <>
            <div>
                {
                    props.dataListItem.map((data) => (
                        <ul className={`font-family-primary tw-f-16 tw-f-20@lg`} key={data.id}>
                            <li
                                className={`font-family-primary fw-7 tw-f-20 tw-f-20@lg bg-white ${s.listStepTitle}`}
                            >
                                <span
                                className={`font-family-primary fw-7 tw-f-16 tw-f-16@lg tw-pt-1@lg ${s.listNum} ${data.id == 1 ? s.listNumNoTop : ''}`}
                                >
                                    {data.id}
                                </span>{' '}
                                <span
                                className={`font-family-secondary dib w-40 w-auto@lg tw-f-16 tw-f-20@lg`}
                                >
                                    {data.title}
                                </span>{' '}
                                {
                                    data.subtitle ? 
                                    <span
                                    className={`h-auto font-family-primary fw-7 tw-f-16 tw-f-16@lg tw-ml-2 tw-ml-6@lg ${s.listNumAnexo}`}
                                    >
                                        {data.subtitle}
                                    </span> : <span></span>
                                }
                            </li>
                            <div
                                className={`font-family-primary tw-f-16 tw-f-16@lg bg-white ${s.listStepContent}`}
                            >
                                {data.content}
                            </div>
                        </ul>
                    ))
                }
            </div>
        
        </>
    )
}

export default ListItem;
